import { Component, OnInit, AfterViewInit } from '@angular/core';
import { Router } from '@angular/router';
import { Location, PlatformLocation } from '@angular/common';
import { window } from 'rxjs';

import { BaseService } from '../../shared-service/base.service';
import { NavbarService } from './navbar.service';
import { LoginService } from './../../login/login.service';
import { EntityType } from '../../shared-service/EntityType';
import { OverviewModule } from '../overview/overview.module';
import { OverviewComponent } from '../overview/overview.component';
import { AuthOIDCService } from '../../auth/authOIDC.service';
import { WindowRef } from '../../shared-service/windowRef.service';
import { environment } from 'src/environments/environment';

// import { KeycloakService } from 'keycloak-angular';


declare var jquery: any;
declare var $: any;
declare var sessionStorage: any;

@Component({
    selector: 'app-main-menu',
    templateUrl: './navbar.component.html',
    styleUrls: ['./navbar.component.css']
})

export class NavbarComponent implements OnInit, AfterViewInit {

    enableColapseMenu: boolean = false;
    isQuickLinkActive: boolean = false;
    isSubMenuActive: boolean = false;
    search: Object | any = {};
    menuCollapse: Object | any = {};
    userImage: string = "";
    userName: string = "";
    CultureList: Array<any> = [];
    UserRoles: Array<any> = [];

    ActiveNotification: boolean = false;
    homePageOption: Array<Text>[] = [];

    enableNotification: boolean = false;
    enableGlobalSearch: boolean = false;
    enableCustomerSupport: boolean = false;
    enableRedDot: boolean = false;
    showActiveWall: boolean = false;

    currentLang: string = '';
    alertCounter: number = 0;
    private params: Object = {};
    private autocmpltsrchtext: string = "";
    private userId: number = 0;
    enableActiveWall: boolean = false;

    constructor(
        public bs: BaseService, private loginService: LoginService, private router: Router, private navbarService: NavbarService, private location: Location, private platformLocation: PlatformLocation,
        private authOIDCService: AuthOIDCService, private winRef: WindowRef) {

        this.search['navbar-form'] = true;
        this.search['open'] = false;
        this.menuCollapse['navbar-collapse'] = true;

        platformLocation.onPopState((e) => {
            let confirmAssessmentMsg = "Confirm Navigation\n\n You will be logged out of the LMS.\n\n Are you sure you want to leave the page?";
            let r = confirm(confirmAssessmentMsg);
            if (r == true) {
                bs.CloseSCORM();
                this.bs.logout();
            }
            else {
                e.state.preventDefault();
                e.state.stopPropagation;
                return false;
            }

        });

    };

    ngOnInit() {

        $('#alertIcon').css('display', 'none');
        $('#globalSearchIcon').css('display', 'none');
        $('#customerSupportIcon').css('display', 'none');

        this.navbarService.setObservableGlobalSearchValue({ "EnableGlobalSearch": false });
        if (sessionStorage.getItem("selectedUserRoleID") != null) {
            this.bs.setUserAttr("SelectedUserRoleId", sessionStorage.getItem("selectedUserRoleID"))
        }
        if (sessionStorage.getItem("selectedCulture") != null) {
            this.bs.setUserAttr("Culture", sessionStorage.getItem("selectedCulture"))
            let lang = sessionStorage.getItem("selectedCulture").substring(0, 2);
            this.currentLang = lang;
            if (sessionStorage.getItem("selectedCulture") == 'ar-AE') {
                $(".bodyClass").addClass('direction-rtl');
            } else {
                $(".bodyClass").removeClass('direction-rtl');
            }
        }
        //get user data from user class of base service
        this.userImage = this.bs.getUserAttr("UserImage");
        this.userName = this.bs.getUserAttr("UserFirstName");
        this.enableActiveWall = this.bs.getUserAttr("IsEnableActiveWall");
        this.CultureList = this.bs.getUserAttr('CultureList');
        this.UserRoles = this.bs.getUserAttr('UserRoles');

        this.navbarService.getQuickLinksFromServer({ 'UserRoleId': this.bs.getUserAttr("SelectedUserRoleId") }, "****").then((data: any) => {
            this.bs.menu = data;

            if (this.bs.IsDeepLinkActive == true) {
                let deepLinkMenu = this.bs.menu['MenuItems'].filter((mnu: any) => mnu["Key"] == this.bs.DeepLinkMenuItemKey)[0];
                this.bs.subMenu = deepLinkMenu['subMenuItems'];
                this.bs.loadSubMenu(deepLinkMenu);
                this.bs.subMenu.filter((sbmnu: any) => sbmnu["Key"] == this.bs.DeepLinkSubmenuItemKey)[0]['isSubMenuActive'] = true;

                this.openCloseNotifications('offsidebar-open');
                this.expandMenu();
                $('.sub-header').show();
            }
            else {
                this.bs.subMenu = this.bs.menu['MenuItems'][0]['subMenuItems'];
                this.loadSubMenu(this.bs.menu['MenuItems'][0]);
            }
            if (this.bs.subMenu.length > 0) {
                this.bs.submenuKey = this.bs.subMenu[0]['Key'];
            }

            for (let i = 0; i < this.bs.menu['MenuItems'].length; i++) {
                for (let s = 0; s < this.bs.menu['MenuItems'][i]['subMenuItems'].length; s++) {
                    let rbkey = this.bs.menu['MenuItems'][i]['subMenuItems'][s];
                    if (rbkey.Key == "rbkey_SkllPthLBL") {
                        this.bs.showSkillRoleBased = true;
                        break;
                    }
                }
                if (this.bs.showSkillRoleBased == true)
                    break;
            }

            if (this.bs.subMenu.length > 4) {
                this.enableColapseMenu = true
            }
            this.getHomePageOption();
        }, (data) => {
            this.bs.log('error', 'Error in getting list');
        });
    };

    ngAfterViewInit() {
        this.RegisterAutoComplete();
        $(".coll-left-arrow").click(function () {
            if ($(".coll-left-arrow").hasClass("learning-la")) {
                $('.coll-left-arrow').toggleClass("left-icon");
                $('.coll-first-left').toggleClass("left-box-show");
                $('.first-right').toggleClass("slide-right");

            }
            if ($(".coll-left-arrow").hasClass("conversation-la")) {
                $('.coll-left-arrow').toggleClass("left-icon");
                $('.conversation-left').toggleClass("conversation-left-box-show");
                $('.conversation-right').toggleClass("conversation-slide-right");
            }
            if ($(".coll-left-arrow").hasClass("blog-la")) {
                $('.coll-left-arrow').toggleClass("left-icon");
                $('.blog-left').toggleClass("blog-left-box-show");
                $('.blog-right').toggleClass("blog-slide-right");
            }
            if ($(".coll-left-arrow").hasClass("survey-la")) {
                $('.coll-left-arrow').toggleClass("left-icon");
                $('.survey-left').toggleClass("survey-left-box-show");
                $('.survey-right').toggleClass("survey-slide-right");
            }

            if ($(".coll-left-arrow").hasClass("leaderboard-la")) {
                $('.coll-left-arrow').toggleClass("left-icon");
                $('.leaderboard-left').toggleClass("leaderboard-left-box-show");
                $('.leaderboard-right').toggleClass("leaderboard-slide-right");
            }
            if ($(".coll-left-arrow").hasClass("profile-button")) {
                $('.coll-left-arrow').toggleClass("left-icon");
                $('.profile-left').toggleClass("profile-left-box-show");
                $('.profile-right').toggleClass("profile-right-slide");
            }
            if ($(".coll-left-arrow").hasClass("skill-la")) {
                $('.coll-left-arrow').toggleClass("left-icon");
                $('.skill-path-left').toggleClass("skill-path-left-box-show");
                $('.skill-path-right').toggleClass("skill-path-slide-right");
            }
            if ($(".coll-left-arrow").hasClass("briefcase-la")) {
                $('.coll-left-arrow').toggleClass("left-icon");
                $('.briefcase-left').toggleClass("briefcase-left-box-show");
                $('.briefcase-right').toggleClass("briefcase-slide-right");
            }
        });

        //Code to toggle language drop down while mouse leave the element
        $("#langDropDown").mouseleave(function () { if ($('#languageList').css("display") == "block") { $('#languageList').toggle(); } });

    }

    RegisterAutoComplete() {
        let currentClass = this;
        $("#globalSearchInput").autocomplete({
            source: function (request: any, response: any) {
                if (request.term != currentClass.autocmpltsrchtext) {
                    currentClass.autocmpltsrchtext = request.term;
                    currentClass.navbarService.getAutoCmplteData(function (data: any) {
                        response($.map(data, function (obj: any, key: any) {
                            if (obj.toUpperCase().indexOf(request.term.toUpperCase()) >= 0) {
                                return {
                                    label: obj, // Label for Display
                                    value: obj // Value
                                }
                            } else {
                                return null;
                            }
                        }));
                    }, currentClass.autocmpltsrchtext, EntityType.MyLearning, "L");
                }
            },
            autoFocus: true,
            html: true,
            minLength: 2,
            delay: 1000,
            open: function (event: any, ui: any) { },
            close: function (event: any, ui: any) {
                currentClass.autocmpltsrchtext = "";
            },
            select: function (event: any, ui: any) {
                $(this).val(ui.item.label);
                currentClass.GlobalSearch();
                $('#searchModal').modal('show');
                $('#LA').trigger('click');
                event.preventDefault();
            },
            scroll: true,
        });
    }


    //TBC....remove subMenu variable, handle in template
    loadSubMenu(item: any) {
        this.bs.loadSubMenu(item);
        this.bs.subMenu[0]['isSubMenuActive'] = true;
        this.bs.isLrngClnder = false;
        this.bs.isTrainingHistory = false;
        this.bs.isReadAndSign = false;

        this.openCloseNotifications('offsidebar-open');
        this.expandMenu();
        if (this.bs.IsSpacedLearning) {
            $('.sub-header').show();
            if (this.bs.subMenu[0]['Action'] == "/learner/overview/container") {
                this.bs.HasOverView = true
            }
            this.routeTo(this.bs.loadModulePath('my_lrng_mdl') + this.bs.getDirectPath('crs_dtl'), { id: this.bs.SpacedLaunchId, IsNodeClick: true }, 'M');
        }
        else {
            if (this.bs.subMenu[0]['Action'] == "/learner/overview/container") {
                this.bs.HasOverView = true
                $('.sub-header').hide();
            } else {
                $('.sub-header').show();
            }

            this.router.navigate([this.bs.subMenu[0]['Action'], { date: new Date().getTime() }]);
            this.bs.setCurrentModulePath(this.bs.subMenu[0]['Action']);
        }
        this.bs.HasOverView = true;
    }
    routeTo(path: string, params: object, menuItem: string) {
        $('.sub-header').show();
        $('body').removeClass('offsidebar-open');
        if (menuItem == 'M' || menuItem == 'H') {
            this.bs.setCurrentModulePath(this.bs.loadModulePath('my_lrng_mdl'));
        }
        this.router.navigate([path, params]).then((res) => {
            console.log(res);
        });
        this.bs.activateMenuItem(menuItem);
    }

    resetNavbar() {
        if ($(window).width() > 768) {
            $('.sub-header').addClass('fixed');
        }
        else {
            $('.sub-header').removeClass('fixed');
        }
    };

    openSubMenu(event: any, id: any) {
        if (id == "language") {
            $('#roleBox').hide();
        }
        if (id == "role") {
            $('#cultureBox').hide();
        }
        if (id == "profileMenu") {
            $('#roleBox').hide();
            $('#cultureBox').hide();
        }
        event.stopPropagation();
        event.preventDefault();
        $('#' + id).next('ul').toggle();
    }

    expandMenu() {
        if (this.menuCollapse['left-menu-show'] == undefined || this.menuCollapse['left-menu-show'] == 'undefined') {
            this.menuCollapse['left-menu-show'] = false;
        } else {
            if (this.menuCollapse['left-menu-show']) {
                this.menuCollapse['left-menu-show'] = false;
            } else {
                this.menuCollapse['left-menu-show'] = true;
            }
        }
    }

    navigate(item: any) {
        this.bs.deActivateSubMenus();
        item['isSubMenuActive'] = true;
        let action = item.Action;
        this.bs.submenuKey = item.Key;
        switch (item.Key) {
            //Overview
            case "rbkey_OvrVwLBL": {
                this.winRef.nativeWindow.document.getElementById('MenuName').style.visibility = "hidden";
                break;
            }
            //My Learning
            case "rbkey_MyLrnngLBL": {
                this.winRef.nativeWindow.document.getElementById('MenuName').style.visibility = "visible";
                this.winRef.nativeWindow.document.getElementById("headerMenuText").innerHTML = this.bs.getResource('rbkey_MyLrnngLBL');
                this.winRef.nativeWindow.document.getElementById('MenuName').className = "coll-left-arrow learning-la switch";
                break;
            }
            case "rbkey_CtlgLBL": {
                this.winRef.nativeWindow.document.getElementById('MenuName').style.visibility = "visible";
                this.winRef.nativeWindow.document.getElementById("headerMenuText").innerHTML = this.bs.getResource('rbkey_CtlgLBL');
                this.winRef.nativeWindow.document.getElementById('MenuName').className = "coll-left-arrow learning-la switch";
                break;
            }
            case "rbkey_VdLbrryLBL": {
                this.winRef.nativeWindow.document.getElementById('MenuName').style.visibility = "visible";
                this.winRef.nativeWindow.document.getElementById('MenuName').className = "coll-left-arrow learning-la switch";
                this.winRef.nativeWindow.document.getElementById("headerMenuText").innerHTML = this.bs.getResource('rbkey_VdLbrryLBL');
                break;
            }
            case "rbkey_SkllPthLBL": {
                this.winRef.nativeWindow.document.getElementById('MenuName').style.visibility = "visible";
                this.winRef.nativeWindow.document.getElementById('MenuName').className = "coll-left-arrow skill-la switch";
                this.winRef.nativeWindow.document.getElementById("headerMenuText").innerHTML = this.bs.getResource('rbkey_SkllPthLBL');
                break;
            }
            case "rbkey_TrnngHstryLBL": {
                this.winRef.nativeWindow.document.getElementById('MenuName').style.visibility = "visible";
                this.winRef.nativeWindow.document.getElementById('MenuName').className = "coll-left-arrow  switch";
                this.winRef.nativeWindow.document.getElementById("headerMenuText").innerHTML = this.bs.getResource('rbkey_TrnngHstryLBL');
                break;
            }
            case "rbkey_DshbrdLBL": {
                this.winRef.nativeWindow.document.getElementById('MenuName').style.visibility = "visible";
                this.winRef.nativeWindow.document.getElementById('MenuName').className = "coll-left-arrow learning-la switch";
                this.winRef.nativeWindow.document.getElementById("headerMenuText").innerHTML = this.bs.getResource('rbkey_DshbrdLBL');
                break;
            }
            case "rbkey_ExtrnlLrnngLBL": {
                this.winRef.nativeWindow.document.getElementById('MenuName').style.visibility = "visible";
                this.winRef.nativeWindow.document.getElementById("headerMenuText").innerHTML = this.bs.getResource('rbkey_ExtrnlLrnngLBL');
                break;
            }
            //collabrate
            case "rbkey_CnvrstnLBL": {
                this.winRef.nativeWindow.document.getElementById('MenuName').style.visibility = "visible";
                this.winRef.nativeWindow.document.getElementById('MenuName').className = "coll-left-arrow conversation-la switch"
                this.winRef.nativeWindow.document.getElementById("headerMenuText").innerHTML = this.bs.getResource('rbkey_CnvrstnLBL');
                break;
            }
            case "rbkey_SrvyLBL": {
                this.winRef.nativeWindow.document.getElementById('MenuName').style.visibility = "visible";
                this.winRef.nativeWindow.document.getElementById('MenuName').className = "coll-left-arrow survey-la switch"
                this.winRef.nativeWindow.document.getElementById("headerMenuText").innerHTML = this.bs.getResource('rbkey_SrvyLBL');
                break;
            }
            case "rbkey_BlgLBL": {
                this.winRef.nativeWindow.document.getElementById('MenuName').style.visibility = "visible";
                this.winRef.nativeWindow.document.getElementById('MenuName').className = "coll-left-arrow blog-la switch"
                this.winRef.nativeWindow.document.getElementById("headerMenuText").innerHTML = this.bs.getResource('rbkey_BlgLBL');
                break;
            }
            case "rbkey_WbmnrLBL": {
                this.winRef.nativeWindow.document.getElementById('MenuName').style.visibility = "visible";
                this.winRef.nativeWindow.document.getElementById('MenuName').className = "coll-left-arrow learning-la switch"
                this.winRef.nativeWindow.document.getElementById("headerMenuText").innerHTML = this.bs.getResource('rbkey_WbmnrLBL');
                break;
            }
            //leader board
            case "rbkey_Ldr_BrdLBL": {
                this.winRef.nativeWindow.document.getElementById('MenuName').style.visibility = "visible";
                this.winRef.nativeWindow.document.getElementById("headerMenuText").innerHTML = this.bs.getResource('rbkey_Ldr_BrdLBL');
                break;
            }
            case "rbkey_ShpngCrt": {
                this.winRef.nativeWindow.document.getElementById('MenuName').style.visibility = "visible";
                this.winRef.nativeWindow.document.getElementById("headerMenuText").innerHTML = this.bs.getResource('rbkey_ShpngCrt');
                break;
            }
            case "rbkey_BrfCsLBL": {
                this.winRef.nativeWindow.document.getElementById('MenuName').style.visibility = "visible";
                this.winRef.nativeWindow.document.getElementById('MenuName').className = "coll-left-arrow briefcase-la switch"
                this.winRef.nativeWindow.document.getElementById("headerMenuText").innerHTML = this.bs.getResource('rbkey_BrfCsLBL');
                break;
            }
        }
        // alert(action);//rbkey_BrfCsLBL
        this.bs.isLrngClnder = false;
        this.bs.isReadAndSign = false;
        this.bs.isTrainingHistory = false;
        if (action == '/learner/learning/container') {
            this.router.navigate([action, { date: new Date().getTime() }]);
        }
        else if (action == '/learner/learning/containerTrainingHistory') {
            //action = '/learner/taskList/container';
            action = '/learner/training/container/learning-list';
            this.bs.isTrainingHistory = true;
            this.router.navigate([action, { date: new Date().getTime() }]);
        }
        else if (action == '/learner/video-library/container') {
            action = '/learner/video-library/container/home';
            this.router.navigate([action, { date: new Date().getTime() }]);
        }
        else if (action == '/learner/overview/container') {
            this.router.navigate(['/learner/overview/container', { date: new Date().getTime() }]);
        }
        else if (action == '/learner/taskList/container/ReadAndSign') {
            action = '/learner/taskList/container';
            this.bs.isReadAndSign = true;
            this.router.navigate([action, { date: new Date().getTime() }]);
            //this.router.navigate([this.bs.getDirectPath('tsk_mdl'), { outlets: { currentTaskList: ['read-and-sign', { time: new Date().getTime(),recordscount: "4", StatusType: "A", id: 0, filterBy: "0", assignedFilterBy: "0"  }] } }]);
        }
        else {
            this.router.navigate([action, { date: new Date().getTime() }]);
        }
        if (action == '/learner/taskList/container') {
            this.bs.isVwLrng = false;
        }
        this.bs.setCurrentModulePath(action);
    };

    async openGlobalSearch(event: any) {
        await this.getUserPrivilegeDetails()
        $("div[id*='esignModalNtfctnAnn']").modal('hide');
        $('#globalSearchInput').val('');
        $("#searchForm").attr("aria-hidden", "false");
        event.stopPropagation();
        event.preventDefault();
        $('#searchForm').addClass("open");   
    };
    closeGlobalSearch() {
        $("#searchForm").attr("aria-hidden", "true");
        $('#searchForm').removeClass("open");
        $('#globalSearchInput').val('');
        this.autocmpltsrchtext = "";
    };

    setCulture(selectedCulture: any) {
        this.winRef.nativeWindow.document.cookie = "CultureCarrier=" + selectedCulture;
        this.bs.setUserAttr("Culture", selectedCulture);
        sessionStorage.setItem("selectedCulture", selectedCulture);
        sessionStorage.setItem("CultureCarrier", selectedCulture);
        sessionStorage.setItem("location", this.location.normalize(this.location.path()));
        location.reload();
    };

    changeRole(roleId: any, roleType: any) {
        sessionStorage.setItem("location", this.location.normalize(this.location.path()));
        if (roleType == 'L') {
            sessionStorage.setItem("selectedUserRoleID", roleId);
            location.reload();

        } else {
            sessionStorage.clear();
            // redirect to wisdom7 admin side with roleId and roleType
            this.winRef.nativeWindow.document.forms["role"].SelectedUserRoleId.value = roleId;
            this.winRef.nativeWindow.document.forms["role"].SelectedCulture.value = sessionStorage.getItem("selectedCulture");
            this.winRef.nativeWindow.document.forms["role"].submit();
        }
    };

    openCloseSystemAlert(classname: any) {
        $('#notificationDiv').show();
        let bodyTag = $('body');
        if (this.ActiveNotification) {
            this.ActiveNotification = false;
            this.navbarService.changeValue({ "EnableNotification": true });
        }

        if (classname) {
            if (bodyTag.hasClass(classname)) {
                bodyTag.removeClass(classname);
                this.ActiveNotification = false;
                this.navbarService.changeValue({ "EnableNotification": true });

            } else {
                this.bs.lastAnnouncementAlertCheck = 0;
                this.bs.lastNotificationAlertCheck = 0;
                this.updateLastAlertCheck();
                bodyTag.addClass(classname);
                this.ActiveNotification = true;
            }
        }
    }

    updateLastAlertCheck() {
        this.params = {
            'UserType': 'L',
        };
        this.navbarService.updateLastUserAlertCheck(this.params, null).then((data) => {
        },
            (data) => {
                this.bs.log('error', 'Error in getting list');
            });
    }

    RedirectCustomerCare() {
        this.bs.deActivateAllMenus();
        this.openCloseNotifications('offsidebar-open');
        this.winRef.nativeWindow.document.getElementById('MenuName').style.visibility = "visible";
        this.winRef.nativeWindow.document.getElementById('MenuName').className = "coll-left-arrow switch learning-la";
        this.winRef.nativeWindow.document.getElementById("headerMenuText").innerHTML = this.bs.getResource('rbkey_CstmrCrlLBL');

        this.router.navigate(['/learner/customer-care/container']);
    }

    getHomePageOption() {
        this.bs.log('info', "getHomePageOption");
        this.navbarService.getHomePageOptionFromServer({}, "****").then((data: any) => {
            this.homePageOption = data['HomePageOptions'];
            this.bs.log('info', this.homePageOption);

            this.homePageOption.forEach(
                (option: any) => {
                    switch (option['Key']) {
                        case 'rbkey_Ntfctn_Anncmnt':
                            this.enableNotification = true;
                            break;
                        case 'rbkey_Spprt':
                            this.enableCustomerSupport = true;
                            break;
                        case 'rbkey_GlblSrchLBL':
                            this.enableGlobalSearch = true;
                            break;
                    }
                });
            if (this.enableNotification) {
                $('#alertIcon').css('display', 'block');

                setTimeout(() => {
                    this.getAnnouncementCount();
                    if (this.bs.isActiveNotification) {
                        this.getNotificationCount();
                    }
                }, 20000);
            }

            setTimeout(() => {
                this.getActiveWallStatus();
                this.startTimer();
            }, 30000);

            if (this.enableGlobalSearch)
                $('#globalSearchIcon').css('display', 'block');

            if (this.enableCustomerSupport)
                $('#customerSupportIcon').css('display', 'block');

        }, (data) => {
            this.bs.log('info', 'Error in getting list');
        });
    }


    getNotificationCount() {
        this.navbarService.getNotificationCountFromServer({}, "Notification").then((data: any) => {
            this.bs.notificationCount = data['TotalNotification'];
            this.bs.lastNotificationAlertCheck = data['LastNotificationAlertCheck'];
            if (this.bs.lastNotificationAlertCheck == 0) {
                $("#NRedCircle").hide();
            }
            else {
                $("#NRedCircle").show();
            }
        }, (data) => {
            this.bs.log('error', 'Error in getting list');
        });
    }

    getAnnouncementCount() {
        this.navbarService.getPublicAnnouncementCountFromServer({}, "Announcement").then((data: any) => {
            this.bs.announcementCount = data['TotalAnnouncement'];
            this.bs.lastAnnouncementAlertCheck = data['LastAnnouncementAlertCheck'];
            if (this.bs.lastAnnouncementAlertCheck == 0) {
                $("#ARedCircle").hide();
            }
            else {
                $("#ARedCircle").show();
            }
        }, (data) => {
            this.bs.log('error', 'Error in getting list');
        });
    }


    getActiveWallStatus() {
        if (this.enableActiveWall == true) {
            this.navbarService.getActiveWallStatusFromServer({}, "ActiveWall").then((res: any) => {
                this.enableRedDot = res['IsActiveWallAvailable'];


            }, (error) => {
                this.bs.log('error', 'Error in getting data from server for active wall status');
            });
        }
    }

    startTimer() {
        setInterval(() => {
            if (this.enableNotification) {
                this.getNotificationCount();
                this.alertCounter = this.alertCounter + 1;
                if (this.alertCounter == 10) {
                    this.getAnnouncementCount();
                    this.alertCounter = 0;
                }
            }
            this.getActiveWallStatus();
        }, environment.notificationInterval);
    }


    openCloseNotifications(classname: any) {
        $("div[id*='esignModalNtfctnAnn']").modal('hide');

        let bodyTag = $('body');
        if (classname) {
            if (bodyTag.hasClass(classname)) {
                bodyTag.removeClass(classname);

            }
        }
    }

    setliClass(index: number) {
        if (index == 0) {
            return '';
        }
        else {
            return 'responsive-470-hide';
        }

    }
    openlang(event: any, id: any) {
        event.stopPropagation();
        event.preventDefault();
        $('#' + id).next('ul').toggle();
    }

    GlobalSearch() {
        $(".topnavbar-wrapper").attr("aria-hidden", "true");
        $(".sub-header").attr("aria-hidden", "true");
        $(".main-section").attr("aria-hidden", "true");
        $("footer").attr("aria-hidden", "true");
        this.navbarService.changeGlobalSearchValue({ "EnableGlobalSearch": true, "GlobalSearchContent": $('#globalSearchInput').val() });
        this.closeGlobalSearch();
    }

    GlobalSearchEnter(event: any) {
        if ($('#globalSearchInput').val().length > 2) {
            if (event.key === "Enter") {
                this.GlobalSearch();
                $('#searchModal').modal('show');
                return false;
            }
        }
        return false;
    };
    navigatetoLastHistory() {
        if (sessionStorage.getItem("location") != null && sessionStorage.getItem("location").toString().indexOf("learner/learning/container") == 0) {
            this.router.navigate([sessionStorage.getItem("location")]);
        }
        else {
            this.router.navigate(['learner/learning']);
        }
    };

    RedirectUserProfile(path: any) {
        let bodyTag = $('body');
        bodyTag.removeClass('offsidebar-open');

        this.bs.deActivateAllMenus();
        this.winRef.nativeWindow.document.getElementById('MenuName').style.visibility = "visible";
        this.winRef.nativeWindow.document.getElementById('MenuName').className = "coll-left-arrow switch profile-button"
        this.winRef.nativeWindow.document.getElementById("headerMenuText").innerHTML = this.bs.getResource('rbkey_PrflLBL');
        this.router.navigate(['/learner/user-profile/container', { RedirectPath: path }]);
    }

    setActiveWallStatus() {
        this.navbarService.setActiveWallStatusFromServer({}, "ActiveWall").then((res) => {
            this.bs.log('success', 'Time logged successfully');
            this.enableRedDot = false;
        }, (error) => {
            this.bs.log('error', 'Error in getting data from server for active wall status');
        });
    }

    OpenCloseActiveWall() {
        if (this.showActiveWall) {
            $('#mainHeader').css("pointer-events", "auto");
            $('#subHeader').css("pointer-events", "auto");
            $('#open_menu').removeClass('open');
            $('#open_menu11').removeClass('open');
            this.showActiveWall = false;
        } else {
            $('#mainHeader').css("pointer-events", "none");
            $('#subHeader').css("pointer-events", "none");
            $('#open_menu').addClass('open');
            $('#open_menu11').addClass('open');
            this.setActiveWallStatus();
            this.showActiveWall = true;
        }
    }

    async getUserPrivilegeDetails() {
        if (this.bs.user['OSVisibilityClaim'] == null || this.bs.user['OSVisibilityClaim'] == undefined) {
            this.userId = this.bs.user['UserId'];
            await this.navbarService.getUserPrivilegeDetails(this.userId, "privilege").then(async (data: any) => {
              this.bs.user['OSVisibilityClaim'] = data.OSVisibilityClaim;
              this.bs.user['RoleVisibilityClaim'] = data.RoleVisibilityClaim;
              this.bs.user['JobRoleVisibilityClaim'] = data.JobRoleVisibilityClaim;
              this.bs.user['RAVisibilityClaim'] = data.RAVisibilityClaim;
              this.bs.user['UserSkills'] = data.UserSkills;
            });
          }
    
      }

    CloseActiveWall() {
        $('#mainHeader').css("pointer-events", "auto");
        $('#subHeader').css("pointer-events", "auto");
        this.bs.activateMenuItem('M');
        $('#open_menu').removeClass('open');
        $('#open_menu11').removeClass('open');
        this.showActiveWall = false;
    }

    logout() {

        // if (this.bs.isDirectLogin) {
        //     sessionStorage.clear();
        //     this.authOIDCService.logout();           
        //     this.winRef.nativeWindow.document.location.href = `${this.bs.config.authServerBaseUrl}realms/${this.bs.config.realm}/protocol/openid-connect/logout?post_logout_redirect_uri=${this.bs.config.lmsBaseUrl}learner&id_token_hint=${this.keycloakService.getKeycloakInstance().idToken}`;
        //     this.keycloakService.logout(location.origin).then(() => this.keycloakService.clearToken()); 
        // }
        this.bs.logout();
    }

}
